import { render } from "./HistoryCompareTable.vue?vue&type=template&id=40f308b9"
import script from "./HistoryCompareTable.vue?vue&type=script&lang=js"
export * from "./HistoryCompareTable.vue?vue&type=script&lang=js"

import "./HistoryCompareTable.vue?vue&type=style&index=0&id=40f308b9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__